import { render, staticRenderFns } from "./etapa_7.vue?vue&type=template&id=151202bc&scoped=true&"
import script from "./etapa_7.vue?vue&type=script&lang=js&"
export * from "./etapa_7.vue?vue&type=script&lang=js&"
import style0 from "./etapa_7.vue?vue&type=style&index=0&id=151202bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151202bc",
  null
  
)

export default component.exports